module.exports = __webpack_public_path__ + "img/platform-analytics-32.75003409.svg";